exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".tooltip---2EXln {\n  position: absolute;\n  color: #000;\n  font-size: 11px;\n  background: #fff;\n  border-radius: 5px;\n  text-shadow: rgba(0, 0, 0, .1) 1px 1px 1px;\n  -webkit-box-shadow: rgba(0, 0, 0, .1) 1px 1px 2px 0;\n          box-shadow: rgba(0, 0, 0, .1) 1px 1px 2px 0; }\n  .tooltip---2EXln.tooltip__defaultStyle---PCNwg {\n    top: -6px;\n    right: 50%;\n    border: 2px solid #c2c2c2; }\n  .tooltip---2EXln.tooltip__defaultStyle---PCNwg::after {\n      border-right: 2px solid #c2c2c2;\n      border-bottom: 2px solid #c2c2c2; }\n  .tooltip---2EXln::after {\n    content: '';\n    display: block;\n    position: absolute;\n    width: 10px;\n    height: 10px;\n    background: #fff;\n    -moz-transform: rotate(-135deg);\n    -webkit-transform: rotate(-135deg); }\n", ""]);

// exports
exports.locals = {
	"tooltip": "tooltip---2EXln",
	"tooltip__defaultStyle": "tooltip__defaultStyle---PCNwg"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules&localIdentName=[local]---[hash:base64:5]!./~/postcss-loader/lib!./~/sass-loader!./app/components/tooltip/index.scss
// module id = 721
// module chunks = 3